import create from 'zustand'
type Action = 'NEXT_PAGE' | 'TOGGLE_PAGE' | undefined;
export const bookContextStore = create((set: any) => ({
  action: undefined as Action,
  fullScreen: true,
  setTurn: () => {
    return set({ action: 'NEXT_PAGE' })
  },
  setAction: () => {
    return set({ action: 'TOGGLE_PAGE' })
  },
  clearAction: () => {
    return set({ action: undefined })
  },
  toggleFullScreen: (fs: boolean) => set({ fullScreen: fs }),
}))
